import React from 'react';
import { useTranslation } from 'react-i18next';
import { getLocalDateKey } from './dateUtils';
import { TimelineOverviewTask, TimelineTaskCard } from './TimelineTaskCard';
import { TimelineRow } from './types';
import { useTimelineView } from './TimelineViewContext';

export const TimelineNonHourRow: React.FC<{ row: TimelineRow }> = ({ row }) => {
    const { t } = useTranslation();
    const {
        creationMenuKey, creationMenuRef, onPickExistingTask, setCreationMenuKey, timelineScale,
    } = useTimelineView();
    const tasks = row.tasks || [];
    const overview = timelineScale === 'year' || timelineScale === 'years';
    const visible = overview ? tasks.slice(0, timelineScale === 'year' ? 3 : 4) : tasks;
    const remaining = tasks.length - visible.length;
    const canCreate = Boolean(row.onCreateFlexible && row.date);
    const openMenu = () => {
        if (canCreate) setCreationMenuKey((current) => current === row.key ? null : row.key);
    };
    return (
        <div className={`timeline-slot timeline-slot-${timelineScale} ${row.isCurrent ? 'current' : ''} ${tasks.length ? '' : 'empty'}`}
            data-timeline-row-date={row.date ? getLocalDateKey(row.date) : undefined}>
            <div className="timeline-label">
                {row.onOpen ? (
                    <button type="button" className="timeline-label-button" onClick={row.onOpen}>
                        <span>{row.label}</span>
                        {overview && tasks.length > 0 && <span className="timeline-row-count">{tasks.length}</span>}
                    </button>
                ) : row.label}
            </div>
            <div className="timeline-task-area" onClick={openMenu} role={canCreate ? 'button' : undefined}
                tabIndex={canCreate ? 0 : undefined}
                onKeyDown={(event) => {
                    if (canCreate && (event.key === 'Enter' || event.key === ' ')) {
                        event.preventDefault();
                        openMenu();
                    }
                }} aria-label={canCreate ? t('dailyPlanner.addTask') : undefined}>
                {visible.map((taskInfo) => overview
                    ? <TimelineOverviewTask key={taskInfo.task.id} taskInfo={taskInfo} />
                    : <TimelineTaskCard key={taskInfo.task.id} taskInfo={taskInfo} />)}
                {remaining > 0 && (
                    <button type="button" className="timeline-more-tasks"
                        onClick={(event) => { event.stopPropagation(); row.onOpen?.(); }}>
                        {t('dailyPlanner.moreTasks', { count: remaining })}
                    </button>
                )}
                {tasks.length === 0 && <span className="timeline-empty-add" aria-hidden="true">+</span>}
                {creationMenuKey === row.key && row.onCreateFlexible && row.date && (
                    <div ref={creationMenuRef} className="timeline-create-choice-menu" role="menu"
                        onClick={(event) => event.stopPropagation()}>
                        <button type="button" role="menuitem" onClick={() => { row.onCreateFlexible?.(); setCreationMenuKey(null); }}>
                            {t('dailyPlanner.newTask')}
                        </button>
                        <button type="button" role="menuitem" onClick={() => { onPickExistingTask(row.date); setCreationMenuKey(null); }}>
                            {t('dailyPlanner.existingTask')}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};
